import React from "react";
import { Modal, Row, Col, Button } from "react-bootstrap";

function EducationInformation({ show, handleClose }) {
  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      size="xl"
    >
      <div
        style={{
          background:"#fff",
          borderRadius:"8px",
          overflow:"hidden"
        }}
      >
        {/* Header */}
        <div
          style={{
            display:"flex",
            justifyContent:"space-between",
            alignItems:"center",
            padding:"22px 24px",
            borderBottom:"1px solid #dbe2ea"
          }}
        >
          <h4 style={{margin:0}}>
            Education Information
          </h4>

          <button
            onClick={handleClose}
            style={{
              border:"none",
              background:"#6b7280",
              color:"#fff",
              width:"30px",
              height:"30px",
              borderRadius:"50%"
            }}
          >
            ✕
          </button>
        </div>

        {/* Body */}
        <div style={{padding:"28px 24px"}}>
          <Row>
            <Col md={6}>
              <label>Institution Name *</label>
              <input
                className="form-control mt-2 mb-4"
              />
            </Col>

            <Col md={6}>
              <label>Course *</label>
              <input
                className="form-control mt-2 mb-4"
              />
            </Col>

            <Col md={6}>
              <label>Start Date *</label>
              <input
                placeholder="dd/mm/yyyy"
                className="form-control mt-2"
              />
            </Col>

            <Col md={6}>
              <label>End Date *</label>
              <input
                placeholder="dd/mm/yyyy"
                className="form-control mt-2"
              />
            </Col>
          </Row>
        </div>

        {/* Footer */}
        <div
          style={{
            borderTop:"1px solid #dbe2ea",
            padding:"16px 24px",
            display:"flex",
            justifyContent:"flex-end",
            gap:"12px"
          }}
        >
          <Button
            variant="light"
            onClick={handleClose}
          >
            Cancel
          </Button>

          <Button
            style={{
              background:"#f97316",
              border:"none"
            }}
          >
            Save
          </Button>
        </div>

      </div>
    </Modal>
  );
}

export default EducationInformation;